import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../services/http';

/** Client errors (4xx) are not retried; network and 5xx errors get two retries with backoff. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
          return failureCount < 2;
        },
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
      },
      mutations: { retry: false },
    },
  });
}
